import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-container" }
const _hoisted_2 = { class: "p-mx-2" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = { class: "m-2 mt-4 mb-4 p-text-center" }
const _hoisted_5 = { class: "p-mt-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "p-text-center p-p-3" }, "No records found", -1)
const _hoisted_7 = { class: "p-dialog-titlebar p-dialog-titlebar-icon" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-search",
  style: {"font-size":"1.2rem"}
}, null, -1)
const _hoisted_9 = { class: "p-field" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { for: "filterStore" }, "Filter Date", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h5", null, "OR", -1)
const _hoisted_12 = { class: "p-grid" }
const _hoisted_13 = { class: "p-col" }
const _hoisted_14 = { class: "p-field" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { for: "from" }, "Date From", -1)
const _hoisted_16 = { class: "p-col" }
const _hoisted_17 = { class: "p-field" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { for: "to" }, "Date To", -1)
const _hoisted_19 = { class: "p-grid" }
const _hoisted_20 = { class: "p-col" }
const _hoisted_21 = { class: "p-field" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { for: "brandName" }, "Brands", -1)
const _hoisted_23 = { class: "p-col" }
const _hoisted_24 = { class: "p-field" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { for: "sectorName" }, "Brand Sectors", -1)
const _hoisted_26 = { class: "p-col" }
const _hoisted_27 = { class: "p-field" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { for: "categoryName" }, "Category", -1)
const _hoisted_29 = { class: "p-col" }
const _hoisted_30 = { class: "p-field" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { for: "productType" }, "Product Type", -1)
const _hoisted_32 = { class: "p-field" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", { for: "filterStore" }, "Batch No", -1)
const _hoisted_34 = { class: "p-grid" }
const _hoisted_35 = { class: "p-col" }
const _hoisted_36 = { class: "p-field" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { for: "type" }, "Report", -1)
const _hoisted_38 = { class: "p-col" }
const _hoisted_39 = { class: "p-field" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", { for: "filterStore" }, "Branch", -1)
const _hoisted_41 = { class: "p-grid" }
const _hoisted_42 = { class: "p-col" }
const _hoisted_43 = { class: "p-field" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", { for: "type" }, "Customer", -1)
const _hoisted_45 = /*#__PURE__*/_createTextVNode(" TITLE : ")
const _hoisted_46 = { class: "pull-right" }
const _hoisted_47 = /*#__PURE__*/_createTextVNode(" Email : ")
const _hoisted_48 = { class: "pull-right" }
const _hoisted_49 = /*#__PURE__*/_createTextVNode(" Contact : ")
const _hoisted_50 = { class: "pull-right" }
const _hoisted_51 = /*#__PURE__*/_createTextVNode(" Account Type : ")
const _hoisted_52 = { class: "pull-right" }
const _hoisted_53 = { class: "p-col" }
const _hoisted_54 = { class: "p-field" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("label", { for: "filterStore" }, "User", -1)
const _hoisted_56 = /*#__PURE__*/_createTextVNode(" NAME : ")
const _hoisted_57 = { class: "pull-right" }
const _hoisted_58 = /*#__PURE__*/_createTextVNode(" Email : ")
const _hoisted_59 = { class: "pull-right" }
const _hoisted_60 = /*#__PURE__*/_createTextVNode(" Contact : ")
const _hoisted_61 = { class: "pull-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Toolbar, null, {
        start: _withCtx(() => [
          _createVNode(_component_Breadcrumb, {
            home: _ctx.home,
            model: _ctx.items,
            class: "p-menuitem-text p-p-1"
          }, null, 8, ["home", "model"])
        ]),
        end: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Button, {
              icon: "pi pi-search",
              class: "p-button-success px-4",
              onClick: _ctx.openDialog
            }, null, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Button, {
              icon: "pi pi-print",
              class: "p-button-primary px-4",
              onClick: _ctx.openDialog
            }, null, 8, ["onClick"])
          ])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h5", null, _toDisplayString(_ctx.searchFilters.type) + " Report", 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.resultTitle), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_DataTable, {
          value: _ctx.lists,
          lazy: true,
          scrollable: true,
          class: "p-datatable-sm p-datatable-striped p-datatable-gridlines"
        }, {
          empty: _withCtx(() => [
            _hoisted_6
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              header: "Store Name",
              style: {"width":"170rem"}
            }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(slotProps.data.branchName) + " (" + _toDisplayString(slotProps.data.branchCode) + ") ", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Date" }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(_ctx.formatDate(slotProps.data.receiptDate)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              field: "receiptNo",
              header: "Receipt No"
            }),
            _createVNode(_component_Column, {
              field: "billNo",
              header: "Bill No"
            }),
            _createVNode(_component_Column, {
              header: "Customer Name",
              style: {"width":"170rem"}
            }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(slotProps.data.customerName) + " (" + _toDisplayString(slotProps.data.customerContact) + ") ", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "User Name" }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(slotProps.data.userName) + " (" + _toDisplayString(slotProps.data.userContact) + ") ", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Item Name" }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(slotProps.data.itemName), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Generic Name" }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(slotProps.data.genericName), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Description" }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(slotProps.data.itemDescription), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Qty" }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(slotProps.data.unit) + "x ", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Free Qty" }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(slotProps.data.freeUnit) + "x ", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Sup Bonus" }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(slotProps.data.supplierBonus) + "x ", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Total Units" }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(slotProps.data.totalUnit) + "x ", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Batch No" }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(slotProps.data.batchNo), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Pack Size" }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(slotProps.data.packSize), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Sheet Size" }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(slotProps.data.sheetSize), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              header: 'Purchase Price (' +_ctx.currency+')'
            }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(_ctx.formatAmount(slotProps.data.purchasePrice)), 1)
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_Column, { header: "Purchase Disc" }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(_ctx.formatAmount(slotProps.data.purchaseDisc)) + " % ", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              header: 'Mrp (' +_ctx.currency+')'
            }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(_ctx.formatAmount(slotProps.data.mrp)), 1)
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_Column, { header: "Cus Disc" }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(_ctx.formatAmount(slotProps.data.itemDisc)) + " % ", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Brand" }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(slotProps.data.brandName), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Sector Name" }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(slotProps.data.sectorName), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Category" }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(slotProps.data.categoryName), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Product Type" }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(slotProps.data.productType), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Expiry" }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(_ctx.formatDate(slotProps.data.expiryDate)), 1)
              ]),
              _: 1
            }),
            (_ctx.taxNames[0].show == 'true')
              ? (_openBlock(), _createBlock(_component_Column, {
                  key: 0,
                  header: _ctx.taxNames[0].taxName + '(%)'
                }, {
                  body: _withCtx((slotProps) => [
                    _createTextVNode(_toDisplayString(_ctx.formatAmount(slotProps.data.tax1)) + " % ", 1)
                  ]),
                  _: 1
                }, 8, ["header"]))
              : _createCommentVNode("", true),
            (_ctx.taxNames[1].show == 'true')
              ? (_openBlock(), _createBlock(_component_Column, {
                  key: 1,
                  header: _ctx.taxNames[1].taxName + '(%)'
                }, {
                  body: _withCtx((slotProps) => [
                    _createTextVNode(_toDisplayString(_ctx.formatAmount(slotProps.data.tax2)) + " % ", 1)
                  ]),
                  _: 1
                }, 8, ["header"]))
              : _createCommentVNode("", true),
            (_ctx.taxNames[2].show == 'true')
              ? (_openBlock(), _createBlock(_component_Column, {
                  key: 2,
                  header: _ctx.taxNames[2].taxName + '(%)'
                }, {
                  body: _withCtx((slotProps) => [
                    _createTextVNode(_toDisplayString(_ctx.formatAmount(slotProps.data.tax3)) + " % ", 1)
                  ]),
                  _: 1
                }, 8, ["header"]))
              : _createCommentVNode("", true),
            _createVNode(_component_Column, {
              header: 'Subtotal (' +_ctx.currency+')'
            }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(_ctx.formatAmount(slotProps.data.subTotal)), 1)
              ]),
              _: 1
            }, 8, ["header"])
          ]),
          _: 1
        }, 8, ["value"])
      ]),
      _createVNode(_component_Dialog, {
        visible: _ctx.productDialog,
        "onUpdate:visible": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.productDialog) = $event)),
        style: { width: '50vw' },
        maximizable: true,
        position: "top",
        class: "p-fluid"
      }, {
        header: _withCtx(() => [
          _createElementVNode("h5", _hoisted_7, [
            _hoisted_8,
            _createTextVNode(" " + _toDisplayString(_ctx.dialogTitle), 1)
          ])
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_Button, {
            type: "submit",
            label: "Search",
            icon: "pi pi-search",
            class: "p-button-primary",
            onClick: _ctx.loadList
          }, null, 8, ["onClick"])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(_component_Dropdown, {
              modelValue: _ctx.searchFilters.filterType,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchFilters.filterType) = $event)),
              options: _ctx.filterDates,
              filter: true,
              optionLabel: "key",
              optionValue: "value"
            }, null, 8, ["modelValue", "options"])
          ]),
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  id: "from",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchFilters.date1) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.searchFilters.date1]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  id: "to",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchFilters.date2) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.searchFilters.date2]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createVNode(_component_Dropdown, {
                  id: "brandName",
                  modelValue: _ctx.searchFilters.brandName,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchFilters.brandName) = $event)),
                  options: _ctx.brands,
                  filter: true,
                  optionLabel: "option_name",
                  optionValue: "option_name"
                }, null, 8, ["modelValue", "options"])
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createVNode(_component_Dropdown, {
                  id: "sectorName",
                  modelValue: _ctx.searchFilters.sectorName,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchFilters.sectorName) = $event)),
                  options: _ctx.sectors,
                  filter: true,
                  optionLabel: "option_name",
                  optionValue: "option_name"
                }, null, 8, ["modelValue", "options"])
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _createVNode(_component_Dropdown, {
                  id: "categoryName",
                  modelValue: _ctx.searchFilters.categoryName,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchFilters.categoryName) = $event)),
                  options: _ctx.categories,
                  filter: true,
                  optionLabel: "option_name",
                  optionValue: "option_name"
                }, null, 8, ["modelValue", "options"])
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _hoisted_31,
                _createVNode(_component_Dropdown, {
                  id: "productType",
                  modelValue: _ctx.searchFilters.productType,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.searchFilters.productType) = $event)),
                  options: _ctx.productTypes,
                  filter: true,
                  optionLabel: "option_name",
                  optionValue: "option_name"
                }, null, 8, ["modelValue", "options"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_32, [
            _hoisted_33,
            _createVNode(_component_InputText, {
              modelValue: _ctx.searchFilters.batchNo,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.searchFilters.batchNo) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _hoisted_37,
                _createVNode(_component_Dropdown, {
                  id: "type",
                  modelValue: _ctx.searchFilters.type,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.searchFilters.type) = $event)),
                  options: _ctx.reportTypes,
                  filter: true,
                  optionLabel: "name",
                  optionValue: "name"
                }, null, 8, ["modelValue", "options"])
              ])
            ]),
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, [
                _hoisted_40,
                _createVNode(_component_Dropdown, {
                  modelValue: _ctx.searchFilters.storeID,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.searchFilters.storeID) = $event)),
                  options: _ctx.filterBranch,
                  filter: true,
                  optionLabel: "name",
                  optionValue: "id"
                }, null, 8, ["modelValue", "options"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _hoisted_44,
                _createVNode(_component_AutoComplete, {
                  delay: 1000,
                  minLength: 3,
                  onItemSelect: _cache[10] || (_cache[10] = ($event: any) => (_ctx.saveProfile($event))),
                  scrollHeight: "500px",
                  modelValue: _ctx.searchFilters.customerName,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.searchFilters.customerName) = $event)),
                  suggestions: _ctx.profilerList,
                  placeholder: "Search Profile",
                  onComplete: _cache[12] || (_cache[12] = ($event: any) => (_ctx.searchProfiler($event))),
                  dropdown: false
                }, {
                  item: _withCtx((slotProps) => [
                    _createElementVNode("div", null, [
                      _hoisted_45,
                      _createElementVNode("b", _hoisted_46, _toDisplayString(slotProps.item.account_title.toUpperCase()), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_47,
                      _createElementVNode("span", _hoisted_48, _toDisplayString(slotProps.item.email_address), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_49,
                      _createElementVNode("span", _hoisted_50, _toDisplayString(slotProps.item.contact_no), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_51,
                      _createElementVNode("span", _hoisted_52, _toDisplayString(slotProps.item.account_type), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "suggestions"])
              ])
            ]),
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("div", _hoisted_54, [
                _hoisted_55,
                _createVNode(_component_AutoComplete, {
                  delay: 1000,
                  minLength: 3,
                  onItemSelect: _cache[13] || (_cache[13] = ($event: any) => (_ctx.saveUser($event))),
                  scrollHeight: "500px",
                  modelValue: _ctx.searchFilters.UserName,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.searchFilters.UserName) = $event)),
                  suggestions: _ctx.userList,
                  placeholder: "Search User",
                  onComplete: _cache[15] || (_cache[15] = ($event: any) => (_ctx.searchUser($event))),
                  dropdown: false
                }, {
                  item: _withCtx((slotProps) => [
                    _createElementVNode("div", null, [
                      _hoisted_56,
                      _createElementVNode("b", _hoisted_57, _toDisplayString(slotProps.item.name.toUpperCase()), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_58,
                      _createElementVNode("span", _hoisted_59, _toDisplayString(slotProps.item.email), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_60,
                      _createElementVNode("span", _hoisted_61, _toDisplayString(slotProps.item.contact), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "suggestions"])
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible"])
    ])
  ]))
}